import { get, post } from "@/utils/utils";

const system = {
  state: {
    roleList: {},
    roleUserList: {},
    allRoleUserList: [],
    roleTreeList: [],
    currentRolePermiision: [],
    storeUserList: [],
    organizationList: [],
    addOrg: [],
    checkOrg: "",
    byIdOrganization: [],
    editOrg: [],
    orgTree: [],
    depotList: [],
    orgByParent: [],
    byIdShop: [],
    shopList: [],
    allEmployeeList: [],
    allEmployee: [],
    mode2List: [],
    expressListAll: {},
    orderReturnList: {
      storeOrderBasicInfoModelPage: {},
    },
    detailsorderReturn: {},
    queryShopList: {
      records: [],
    },
    msgTemplatesList: {},
    treeStructByParent: [],
    tempTypeList: [],
    wxLoginUuidInfo: {},
  },
  mutations: {
    QUERY_SUBSCRIBE_MSG_TYPE(state, data) {
      state.subscribeTempTypeList = data.result;
    },
    QUERY_USER_ROLE_LIST(state, data) {
      state.roleList = data.result;
    },
    ADD_ROLE(state, data) {
      state.addRoleCode = data.result;
    },
    EDIT_ROLE(state, data) {
      state.editRoleCode = data.result;
    },
    DELETE_ROLE(state, data) {
      state.deleteRoleCode = data.result;
    },
    QUERY_ROLE_USER_LIST(state, data) {
      state.roleUserList = data.result;
    },
    QUERY_ALL_USER_ROLE_LIST(state, data) {
      state.allRoleUserList = data.result.records;
    },
    QUERY_ROLE_TREE_LIST(state, data) {
      state.roleTreeList = data.result.treeList;
    },
    QUERY_CURRENT_ROLE_PERMISSION(state, data) {
      state.currentRolePermiision = data.result;
    },
    SAVE_ROLE_PERMISSION(state, data) {
      state.saveRolePermissionCode = data.result;
    },
    ADD_USER(state, data) {
      state.addUserCode = data.result;
    },
    EDIT_USER(state, data) {
      state.editUserCode = data.result;
    },
    DELETE_ROLE_USER(state, data) {
      state.deleteUserRoleCode = data.result;
    },
    QUERY_STORE_USER_lIST(state, data) {
      state.storeUserList = data.result;
    },
    ADD_EXSIST_USER(state, data) {
      state.addExistUserCode = data.result;
    },
    //组织架构列表
    QUERY_ORGANIZATION_LIST(state, data) {
      state.organizationList = data.result;
      if (state.organizationList.records) {
        state.organizationList.records.forEach((v) => {
          v.hasChildren = Boolean(v.isParent);
        });
      }
    },
    QUERY_PAGE_DEPART_INFO_LIST() {},
    QUERY_ORGANIZATION_LIST_TREE() {},
    QUERY_ORGANIZATION_INDEX_LIST(state, data) {
      state.organizationList = data.result;
      if (state.organizationList.records) {
        state.organizationList.records.forEach((v) => {
          v.hasChildren = Boolean(v.isParent);
        });
      }
    },
    //新增组织架构
    ADD_ORGANIZATION(state, data) {
      state.addOrg = data.result;
    },
    //验证重复
    CHECK_ORGANIZATION(state, data) {
      state.checkOrg = data.result;
    },
    //通过ID查询
    BYID_ORGANIZATION(state, data) {
      state.byIdOrganization = data.result;
    },
    //修改组织架构
    EDIT_ORGANIZATION(state, data) {
      state.editOrg = data.result;
    },
    ORGANIZATION_BYPARENT(state, data) {
      state.orgByParent = data.result;
      state.orgByParent.forEach((v) => {
        v.leaf = Boolean(v.isParent);
        v.all = {
          label: v.departName,
          value: v.id,
        };
      });
    },
    // ORGANIZATION_BYPARENT(state, data) {
    //   state.orgByParent = data.result.records;
    //   state.orgByParent.forEach(v => {
    //     v.leaf = Boolean(v.isParent);
    //     v.all = {
    //       label: v.departName,
    //       value: v.id
    //     };
    //   });
    // },
    ORGANIZATION_TREE(state, data) {
      state.orgTree = data.result;
      state.orgTree.records.forEach((v) => {
        v.leaf = Boolean(v.isParent);
        v.all = {
          label: v.departName,
          value: v.id,
        };
      });
    },
    //仓库管理列表
    QUERY_DEPOT_LIST(state, data) {
      state.depotList = data.result;
    },
    //查找仓库
    BYID_DEPOT(state, data) {
      state.byIdDepot = data.result;

      state.byIdDepot.shopLists = [];
      state.byIdDepot.shopList.map((v) => {
        state.byIdDepot.shopLists.push(v.shopId);
      });
    },
    //查找商店
    BYID_SHOP(state, data) {
      state.queryShopList = data.result;
    },
    //编辑仓库
    EDIT_DEPOT(state, data) {
      state.editDe = data.result;
    },
    ADD_DEPOT(state, data) {
      state.addDe = data.result;
    },
    //查询商店列表
    QUERY_SHOP_LIST(state, data) {
      state.shopList = data.result;
    },
    //商店id查询详情
    QUERY_BYID_SHOP(state, data) {
      state.byIdShop = data.result;
    },
    //查询所有雇员
    QUERY_EMPLOYEE(state, data) {
      state.allEmployee = data.result.records;
    },
    //新增商店
    ADD_SHOP(state, data) {
      state.addShop = data.result;
    },
    //编辑商店
    DEIT_SHOP(state, data) {
      state.deitShop = data.result;
    },
    //查找地图
    SEARCH_MAP(state, data) {
      state.map = data.result;
    },
    //职员列表查询
    EMPLOYEE_LIST(state, data) {
      state.allEmployeeList = data.result;
    },
    //职员id查询
    BYID_EMPLOYEE(state, data) {
      state.byIdEmployee = data.result;
    },
    //验证重复
    CHECK_EMPLOYEE(state, data) {
      state.checkEmployee = data.result;
    },
    //添加用户
    ADD_EMPLOYEE(state, data) {
      state.addEmployee = data.result;
    },
    //编辑用户
    EDIT_EMPLOYEE(state, data) {
      state.editEmployee = data.result;
    },
    //商城商店配送配置-通过ID获取详情
    DETAILS_SHOP_EXPRESS(state, data) {
      state.detailsShopaExpress = data.result;
    },
    EXPRESS_MODE2_LIST(state, data) {
      state.mode2List = data.result;
    },
    //选择指定区域
    EXPRESS_LIST_ALL(state, data) {
      state.expressListAll = data.result;
    },
    //商城商店配送配置-编辑
    EDIT_EXPRESS_CONFIG(state, data) {
      state.editExpressConfi = data.result;
    },
    ORDE_RRETURN_LIST(state, data) {
      state.orderReturnList = data.result;
    },
    DETAILS_ORDE_RRETURN(state, data) {
      state.detailsorderReturn = data.result;
      state.detailsorderReturn.status = [];
      if (state.detailsorderReturn.returnOrder.returnConfirmOperator) {
        state.detailsorderReturn.status.push({
          operator: state.detailsorderReturn.returnOrder.returnConfirmOperator,
          val: "核定信息",
          time: state.detailsorderReturn.returnOrder.returnConfirmTime,
        });
      }
      if (state.detailsorderReturn.returnOrder.refundOperator) {
        state.detailsorderReturn.status.push({
          operator: state.detailsorderReturn.returnOrder.refundOperator,
          val: "确定退货/退款",
          time: state.detailsorderReturn.returnOrder.refundTime,
        });
      }
    },
    ORDER_RETURN_UPD(state, data) {
      state.orderUpd = data.result;
    },
    ORDE_ALL_RRETURN_LIST(state, data) {
      state.orderAllReturnList = data.result;
    },
    //消息模板列表
    MSG_TEMPLATE_LIST(state, data) {
      state.msgTemplatesList = data.result;
    },
    //消息模板详情
    DETAILS_MSG_TEMPLATE(state, data) {
      state.detailsMsgTemplates = data.result;
    },
    //消息模板编辑
    EDIT_MSG_TEMPLATE(state, data) {
      state.editMsgTemplates = data.result;
    },
    // 美素新客判断
    IS_FRISO() {},
    ALL_EMPLOYEE_LIST() {},
    ORDE_RRETURN_GOODS_LIST() {},
    ORDE_REFUND_RECORD_LIST() {},
    ORGANIZATION_QUERYLIST_BYPARENT(state, data) {
      state.treeStructByParent = data.result;
      state.treeStructByParent.forEach((v) => {
        v.leaf = Boolean(v.isParent);
        v.all = {
          label: v.departName,
          value: v.treeStruct || v.id,
        };
      });
    },
    ORGANIZATION_QUERYLIST_BYPARENT_NEW() {},
    OCR_RULE_CONFIG() {},
    QUERY_EXPORT_QUEUE_LIST() {},
    REMOVE_QUEUE_ROW() {},
    DOWNLOAD_FILE() {},
    QUERY_CONFIG_REFUNDAMOUNT() {},
    QUERY_EXPORT_QUEUE_SIGN() {},
    SYNC_TARGET_ID() {},
    SYNC_TARGET_GOODS_SN() {},
    SYNC_GOODS_BY_ATTACH_BARCODES() {},
    INTERFACE_TEXT_INFO_LIST() {},
    QUERY_TEXT_TYPE() {},
    ADD_INTERFACE_TEXT_INFO() {},
    EDIT_INTERFACE_TEXT_INFO() {},
    SYS_EXCEPTION_LOG_LIST() {},
    INTERFACE_POPVER_LIST() {},
    ADD_INTERFACE_POPVER() {},
    DOWNLOAD_REPORT() {},
    ACCOUNT_UNFREEZING() {},
    ACCOUNT_FREEZING() {},
    QUERY_ALL_EMPLOYEE_LABEL_NAME() {},
    USER_ID_LIST_ADD_ROLE() {},
    QUERY_STORE_INTERFACE_TEXT_INFO() {},
    QUERY_LOGIN_CUSTOM_LOGO_DATE_RANGE() {},
    SAVE_SHOP_TO_DADA() {},
    QUERY_THIRD_SHOP_INFO() {},
    EDIT_SHOP_TO_DADA() {},
    QUERY_GZH_SUBSCRIBE_MSG_TYPE() {},
    QUERY_WX_LOGIN_STATE() {},
    UUID_INFO(state, data) {
      state.wxLoginUuidInfo = data;
    },
    ALIYUN_IP_WHITE_LIST() {},
    SET_ALIYUN_IP_WHITE_LIST() {},
    QUERY_STORE_SHOP_DEPART_LIST() {},
    QUERY_DEPART_INFO_BY_SHOP_ID_FOR_STORE() {},
    QUERY_STORE_ALL_ENABLED_STATUS_SHOP_LIST() {},
    QUERY_STORE_OPEN_CHANGE_SHOP() {},
    QUERY_MPS_FUNC_INFO_PAGE_LIST() {},
    EDIT_MPS_FUNC_ENABLED_STATE() {},
    ADD_MPS_FUNC_INFO() {},
    QUERY_MPS_FUNC_VERSION_PAGE_LIST() {},
    QUERY_MPS_FUNC_WHITE_CONFIG_PROVINCE() {},
    QUERY_MPS_FUNC_WHITE_CONFIG_STORE() {},
    QUERY_MPS_FUNC_WHITE_CONFIG_SHOP() {},
    QUERY_MPS_FUNC_WHITE_CONFIG_GUIDER() {},
    SAVE_MPS_FUNC_WHITE_CONFIG() {},
    SEARCH_WHITE_CONFIG_TREE() {},
    QUERY_CHECKED_MPS_FUNCSTORE_CUSTOMER_CONFIG() {},
    QUERY_SUPPLIER_AUDIT_LIST() {},
    SAVE_SUPPLIER_AUDIT() {},
    EDIT_SUPPLIER_AUDIT() {},
    BULK_OPERCONFIGS() {},
    EDIT_DEL_FLAG_SUPPLIER_AUDIT() {},
    EDIT_ORGANIZATION_BASIC() {},
    STORE_ADDRESS_INFO_ADD() {},
    STORE_ADDRESS_INFO_QUERY_PAGE_LIST() {},
    STORE_ADDRESS_INFO_DELETE() {},
    SAOBEI_LIST() {},
    SAOBEI_ADD() {},
    SAOBEI_EDIT() {},
    SAOBEI_DELETE() {},
    REMOVE_AUDIT_MANAGER() {},
    ADD_AUDIT_MANAGER() {},
    STORE_SYSTEM_PARAM_INFOQUERY_PAGE_LIST() {},
    EDIT_VALUE_BY_ID() {},
    ONLINE_LIST() {},
    FROZEN_USERNAME() {},
    FORCE_LOGOUT() {},
    SHOW_SUPER_ADMIN() {},
    SET_SUPER_ADMIN() {},
    QUERY_CACHE_COUNT() {},
    CLEAR_CACHE() {},
    QUERY_CACHE_SETTINGS() {},
    UPDATE_CACHE_SETTINGS() {},
    OMS_ORDER_SEND_PAGE() {},
    OMS_ORDER_REFUND_INFO_PAGE() {},
    QUERY_REWARD_GOODS_IMPORT_ES_PAGELIST(){},
    GET_VOLCENGINE_OCR_RESULT(){},
    QUERY_SERVICE_PROJECT_INFO_SHOP_STAFF_PAGE() {},
    QUERY_SHOP_BY_SERVICE_SHOP_CODE_PAGE() {},
    SAVE_SERVICE_PROJECT_INFO_SHOP_REL() {},
    GET_A_LIST_OF_TECHNICIANS() {},
    QUERY_PROJECT_INFO_SERVICE_SHOP_PAGE() {},
    ADD_A_TECHNICIAN() {},
    UPDATE_STAFF_IS_ENABLED() {},
    QUERY_LEVEL_SERVICE_RESTORATION_TYPE_LIST() {},
    UPDATE_SERVICE_STAFF_BY_SECOND_LEVEL_LIST() {},
    DEL_SERVICE_PROJECT_INFO() {},
    QUERY_LEVEL_SERVICE_SHOP_PROJECT_STAFF_LIST() {},
    QUERY_APPLY_RECORD_STAFF_FEEDBACK_PAGE() {},
    GET_STAFF_REPOSE_DATE_LIST() {},
    ADD_STAFF_REPOSE_DATE() {},
    STORE_SERVICE_TECHNICIAN_STAFF_EDIT() {},
    TECHNICIAN_STAFF_QUERY_BY_ID() {},
    STORE_SHOP_EMPLOYEE_FINANCE_REL_IMPORT_SHOP() {},
    STORE_SHOP_INFO_EXPORT() {},
    THIRD_COMPANY_OPEN_PLATFORM_CONFIG_QUERY_PAGE_LIST(){},
    THIRD_COMPANY_OPEN_PLATFORM_CONFIG_ADD(){},
    THIRD_COMPANY_OPEN_PLATFORM_CONFIG_UPDATE(){},
    THIRD_COMPANY_OPEN_PLATFORM_CONFIG_GENERATE_ACCESS_KEY_PAIR(){},
    THIRD_COMPANY_OPEN_PLATFORM_CONFIG_OPERATION_RECORD(){},
    QUERY_CALLBACK_LOG_BIZ_TYPE(){},
    QUERY_CALLBACK_LOG_FINISH_STATE(){},  
    GET_PROVINCE_CITY_AREA_JSON(){},
    GET_REFUND_CANCEL_RETRY(){}
  },
  actions: {
    technicianStaffQueryById({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/small/technicianStaff/queryById`,
        name: "TECHNICIAN_STAFF_QUERY_BY_ID",
        params,
      });
    },
    storeServiceTechnicianStaffEdit({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/edit`,
        name: "STORE_SERVICE_TECHNICIAN_STAFF_EDIT",
        params,
      });
    },
    addStaffReposeDate({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/addStaffReposeDate`,
        name: "ADD_STAFF_REPOSE_DATE",
        params,
      });
    },
    getStaffReposeDateList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/getStaffReposeDateList`,
        name: "GET_STAFF_REPOSE_DATE_LIST",
        params,
      });
    },
    queryApplyRecordStaffFeedbackPage({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/queryApplyRecordStaffFeedbackPage`,
        name: "QUERY_APPLY_RECORD_STAFF_FEEDBACK_PAGE",
        params,
      });
    },
    updateServiceStaffIdsBySecondLevelList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/updateServiceStaffIdsBySecondLevelList`,
        name: "QUERY_LEVEL_SERVICE_SHOP_PROJECT_STAFF_LIST",
        params,
      });
    },
    queryLevelServiceShopProjectStaffList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/queryLevelServiceShopProjectStaffList`,
        name: "QUERY_LEVEL_SERVICE_SHOP_PROJECT_STAFF_LIST",
        params,
      });
    },
    //服务删除
    delServiceProjectInfo({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/delServiceProjectInfo`,
        name: "DEL_SERVICE_PROJECT_INFO",
        params,
      });
    },
    //编辑
    updateServiceStaffBySecondLevelList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/updateServiceStaffBySecondLevelList`,
        name: "UPDATE_SERVICE_STAFF_BY_SECOND_LEVEL_LIST",
        params,
      });
    },
    //预约范围
    queryLevelServiceRestorationTypeList({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/serviceRestoration/queryLevelServiceRestorationTypeList`,
        name: "QUERY_LEVEL_SERVICE_RESTORATION_TYPE_LIST",
        params,
      });
    },
    updateStaffIsEnabled({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/updateStaffIsEnabled`,
        name: "UPDATE_STAFF_IS_ENABLED",
        params,
      });
    },
    addATechnician({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/addBatch`,
        name: "ADD_A_TECHNICIAN",
        params,
      });
    },
    queryProjectInfoServiceShopPage({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceShop/queryProjectInfoServiceShopPage`,
        name: "QUERY_PROJECT_INFO_SERVICE_SHOP_PAGE",
        params,
      });
    },
    getAListOfTechnicians({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/queryPageList`,
        name: "GET_A_LIST_OF_TECHNICIANS",
        params,
      });
    },
    saveServiceProjectInfoShopRel({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceProjectInfo/saveServiceProjectInfoShopRel`,
        name: "SAVE_SERVICE_PROJECT_INFO_SHOP_REL",
        params,
      });
    },
    queryShopByServiceShopCodePage({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/storeShopInfo/queryShopByServiceShopCodePage`,
        name: "QUERY_SHOP_BY_SERVICE_SHOP_CODE_PAGE",
        params,
      });
    },
    queryServiceProjectInfoShopStaffPage({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/serviceRestoration/storeServiceTechnicianStaff/queryServiceProjectInfoShopStaffPage`,
        name: "QUERY_SERVICE_PROJECT_INFO_SHOP_STAFF_PAGE",
        params,
      });
    },
    queryLoginCustomLogoDateRange({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items_noToken?dictCode=custom_back_login_logo`,
        name: "QUERY_LOGIN_CUSTOM_LOGO_DATE_RANGE",
        params,
      });
    },
    querySubscribeMsgType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=subscribeMsgType`,
        name: "QUERY_SUBSCRIBE_MSG_TYPE",
        params,
      });
    },
    queryGzhSubscribeMsgType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=gzhSubscribeMsgType`,
        name: "QUERY_GZH_SUBSCRIBE_MSG_TYPE",
        params,
      });
    },
    queryStoreInterFaceTextInfo({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/video`,
        name: "QUERY_STORE_INTERFACE_TEXT_INFO",
        params,
      });
    },
    accountFreezing({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/frozenUsername`,
        name: "ACCOUNT_FREEZING",
        params,
      });
    },
    accountUnfreezing({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/unfrozenUsername`,
        name: "ACCOUNT_UNFREEZING",
        params,
      });
    },
    addExistUser({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/addSysUserRole`,
        name: "ADD_EXSIST_USER",
        params,
      });
    },
    queryStoreUserList({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/listNoRole`,
        name: "QUERY_STORE_USER_lIST",
        params,
      });
    },
    deleteUserRole({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/deleteUserRole`,
        name: "DELETE_ROLE_USER",
        params,
      });
    },
    addUser({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/add`,
        name: "ADD_USER",
        params,
      });
    },
    editUser({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/edit`,
        name: "EDIT_USER",
        params,
      });
    },
    saveRolePermission({ commit }, params) {
      return post({
        commit,
        url: `/sys/permission/saveRolePermission`,
        name: "SAVE_ROLE_PERMISSION",
        params,
      });
    },
    queryCurrentRolePermission({ commit }, params) {
      return get({
        commit,
        url: `/sys/permission/queryRolePermission`,
        name: "QUERY_CURRENT_ROLE_PERMISSION",
        params,
      });
    },
    queryRoleTreeList({ commit }, params) {
      return get({
        commit,
        url: `/sys/role/queryTreeList`,
        name: "QUERY_ROLE_TREE_LIST",
        params,
      });
    },
    editRole({ commit }, params) {
      return post({
        commit,
        url: `/sys/role/edit`,
        name: "EDIT_ROLE",
        params,
      });
    },
    deleteRole({ commit }, params) {
      return post({
        commit,
        url: `/sys/role/delete`,
        name: "DELETE_ROLE",
        params,
      });
    },
    queryRoleList({ commit }, params) {
      return post({
        commit,
        url: `/sys/role/list`,
        name: "QUERY_USER_ROLE_LIST",
        params,
      });
    },
    queryAllRoleList({ commit }, params) {
      return post({
        commit,
        url: `/sys/role/list`,
        name: "QUERY_ALL_USER_ROLE_LIST",
        params,
      });
    },
    queryRoleUserList({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/userRoleList`,
        name: "QUERY_ROLE_USER_LIST",
        params,
      });
    },
    addRole({ commit }, params) {
      return post({
        commit,
        url: `/sys/role/add`,
        name: "ADD_ROLE",
        params,
      });
    },

    //组织架构列表
    queryOrganizationList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/list`,
        name: "QUERY_ORGANIZATION_LIST",
        params,
      });
    },
    //组织架构列表
    queryPageDepartInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/queryPageDepartInfoList`,
        name: "QUERY_PAGE_DEPART_INFO_LIST",
        params,
      });
    },
    queryOrganizationListTree({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/list`,
        name: "QUERY_ORGANIZATION_LIST_TREE",
        params,
      });
    },
    queryOrganizationIndexList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/indexList`,
        name: "QUERY_ORGANIZATION_INDEX_LIST",
        params,
      });
    },
    //新增组织架构
    addOrganization({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/add`,
        name: "ADD_ORGANIZATION",
        params,
      });
    },
    //验证重复
    checkOrganization({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/check`,
        name: "CHECK_ORGANIZATION",
        params,
      });
    },
    //通过ID查询
    queryByIdOrganization({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/queryById`,
        name: "BYID_ORGANIZATION",
        params,
      });
    },
    //修改组织架构
    editOrganization({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/edit`,
        name: "EDIT_ORGANIZATION",
        params,
      });
    },
    queryListOrganizationListByParent({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/querylist`,
        name: "ORGANIZATION_QUERYLIST_BYPARENT",
        params,
      });
    },
    queryListOrganizationListByParentNew({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/querylist`,
        name: "ORGANIZATION_QUERYLIST_BYPARENT_NEW",
        params,
      });
    },
    queryOrganizationListByParent({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/sonlist`,
        name: "ORGANIZATION_BYPARENT",
        params,
      });
    },

    queryIsFriso({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query `,
        name: "IS_FRISO",
        params,
      });
    },
    // 查询是否是美素新客
    queryOrganizationTree({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/indexList`,
        name: "ORGANIZATION_TREE",
        params,
      });
    },
    //仓库管理列表
    queryDepotListList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepotInfo/list`,
        name: "QUERY_DEPOT_LIST",
        params,
      });
    },
    //查找仓库
    queryByIdDepot({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepotInfo/queryById`,
        name: "BYID_DEPOT",
        params,
      });
    },
    //查找商店
    queryByIdshop({ commit }) {
      return post({
        commit,
        url: `/store/storeShopInfo/list`,
        name: "BYID_SHOP",
      });
    },

    //编辑仓库
    editDepot({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepotInfo/edit`,
        name: "EDIT_DEPOT",
        params,
      });
    },
    //编辑仓库
    addDepot({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepotInfo/add`,
        name: "ADD_DEPOT",
        params,
      });
    },
    //查询商店列表
    queryShopList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/list`,
        name: "QUERY_SHOP_LIST",
        params,
      });
    },
    //商店id查询详情
    queryByIdShop({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryById`,
        name: "QUERY_BYID_SHOP",
        params,
      });
    },
    //查询所有雇员
    queryEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/list`,
        name: "QUERY_EMPLOYEE",
        params,
      });
    },
    //新增商店
    addShop({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/add`,
        name: "ADD_SHOP",
        params,
      });
    },
    //编辑商店
    editShop({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/edit`,
        name: "DEIT_SHOP",
        params,
      });
    },
    //查询地址
    querySearchAddress({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/map`,
        name: "SEARCH_MAP",
        params,
      });
    },
    //职员列表查询
    queryEmployeeList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/list`,
        name: "EMPLOYEE_LIST",
        params,
      });
    },

    queryAllEmployeeList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/list`,
        name: "ALL_EMPLOYEE_LIST",
        params,
      });
    },
    //职员id查询
    queryByIdEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/queryById`,
        name: "BYID_EMPLOYEE",
        params,
      });
    },
    //验证重复
    checkEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/check`,
        name: "CHECK_EMPLOYEE",
        params,
      });
    },
    //添加用户
    addEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/add`,
        name: "ADD_EMPLOYEE",
        params,
      });
    },
    //编辑用户
    editEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/edit`,
        name: "EDIT_EMPLOYEE",
        params,
      });
    },
    //商城商店配送配置-通过ID获取详情
    detailsShopaExpress({ commit }, params) {
      return post({
        commit,
        url: `/storeShopExpressConfig/findStoreShopExpressConfigById`,
        name: "DETAILS_SHOP_EXPRESS",
        params,
      });
    },
    expressMode2List({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=express_mode2`,
        name: "EXPRESS_MODE2_LIST",
        params,
      });
    },
    //选择指定区域
    expressListAll({ commit }, params) {
      return post({
        commit,
        url: `/storeExpressConfig/findStoreExpressList`,
        name: "EXPRESS_LIST_ALL",
        params,
      });
    },
    //商城商店配送配置-编辑
    editExpressConfig({ commit }, params) {
      return post({
        commit,
        url: `/storeShopExpressConfig/editStoreShopExpressConfig`,
        name: "EDIT_EXPRESS_CONFIG",
        params,
      });
    },
    //售后订单列表
    queryOrderReturnList({ commit }, params) {
      return post({
        commit,
        url: `/order/order_return_list`,
        name: "ORDE_RRETURN_LIST",
        params,
      });
    },
    //售后订单商品列表
    queryReturnGoodsList({ commit }, params) {
      return post({
        commit,
        url: `/order/order_refund_list`,
        name: "ORDE_RRETURN_GOODS_LIST",
        params,
      });
    },
    queryOrderRefundRecordList({ commit }, params) {
      return post({
        commit,
        url: `/storeOrderRefundRecord/list`,
        name: "ORDE_REFUND_RECORD_LIST",
        params,
      });
    },
    //售后导出订单列表
    queryALLOrderReturnList({ commit }, params) {
      return post({
        commit,
        url: `/order/export_order_return_list`,
        name: "ORDE_ALL_RRETURN_LIST",
        params,
      });
    },
    //售后订单详情
    detailsOrderReturn({ commit }, params) {
      return post({
        commit,
        url: `order/order_return_show`,
        name: "DETAILS_ORDE_RRETURN",
        params,
      });
    },
    //确认售后订单
    orderReturnUpd({ commit }, params) {
      return post({
        commit,
        url: `order/order_return_upd`,
        name: "ORDER_RETURN_UPD",
        params,
      });
    },
    //消息模板列表
    msgTemplatesList({ commit }, params) {
      return post({
        commit,
        url: `/mp_message/storeMessageTemplatesConfig/list`,
        name: "MSG_TEMPLATE_LIST",
        params,
      });
    },
    //消息模板详情
    detailsMsgTemplates({ commit }, params) {
      return post({
        commit,
        url: `/mp_message/storeMessageTemplatesConfig/queryById`,
        name: "DETAILS_MSG_TEMPLATE",
        params,
      });
    },
    //消息模板编辑
    editMsgTemplates({ commit }, params) {
      return post({
        commit,
        url: `/mp_message/storeMessageTemplatesConfig/edit`,
        name: "EDIT_MSG_TEMPLATE",
        params,
      });
    },
    ocrRuleConfig({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=ocr_rule_config`,
        name: "OCR_RULE_CONFIG",
        params,
      });
    },
    removeQueueRow({ commit }, params) {
      return post({
        commit,
        url: `/store/storeExportFileRecord/delete`,
        name: "REMOVE_QUEUE_ROW",
        params,
      });
    },
    queryExportQueueList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeExportFileRecord/queryExportQueue`,
        name: "QUERY_EXPORT_QUEUE_LIST",
        params,
      });
    },
    downloadFile({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/download?fileName=${params.exportSuccFilePath}`,
        name: "DOWNLOAD_FILE",
        params,
      });
    },
    queryConfigRefundAmount({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/query`,
        name: "QUERY_CONFIG_REFUNDAMOUNT",
        params,
      });
    },
    queryExportQueueSign({ commit }, params) {
      return post({
        commit,
        url: `/store/storeExportFileRecord/viewExportQueueSign`,
        name: "QUERY_EXPORT_QUEUE_SIGN",
        params,
      });
    },
    syncTargetId({ commit }, params) {
      return post({
        commit,
        url: `/thirderp/syncTargetId`,
        name: "SYNC_TARGET_ID",
        params,
      });
    },
    syncTargetGoodsSn({ commit }, params) {
      return post({
        commit,
        url: `/thirderp/syncStockByGoodsSn`,
        name: "SYNC_TARGET_GOODS_SN",
        params,
      });
    },
    syncGoodsByAttachBarcodes({ commit }, params) {
      return post({
        commit,
        url: `/thirderp/syncGoodsByAttachBarcodes`,
        name: "SYNC_GOODS_BY_ATTACH_BARCODES",
        params,
      });
    },
    interfaceTextInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/interfaceTextInfo/list`,
        name: "INTERFACE_TEXT_INFO_LIST",
        params,
      });
    },
    addInterfaceTextInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/interfaceTextInfo/add`,
        name: "ADD_INTERFACE_TEXT_INFO",
        params,
      });
    },
    queryTextType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=interface_text_type`,
        name: "QUERY_TEXT_TYPE",
        params,
      });
    },
    sysExceptionLogList({ commit }, params) {
      return post({
        commit,
        url: `/store/sysExceptionLog/queryPageList`,
        name: "SYS_EXCEPTION_LOG_LIST",
        params,
      });
    },
    interfacePopoverInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/interfacePopoverInfo/queryPageList`,
        name: "INTERFACE_POPVER_LIST",
        params,
      });
    },
    addInterfacePopoverInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/interfacePopoverInfo/add`,
        name: "ADD_INTERFACE_POPVER",
        params,
      });
    },
    downloadReport({ commit }, params) {
      return get({
        commit,
        url: `/sys/common/download`,
        name: "DOWNLOAD_REPORT",
        params,
        responseType: "arraybuffer",
      });
    },
    queryAllEmployeeLabelName({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/queryAllEmployeeLabelName`,
        name: "QUERY_ALL_EMPLOYEE_LABEL_NAME",
        params,
      });
    },
    userIdListAddRole({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/userIdListAddRole`,
        name: "USER_ID_LIST_ADD_ROLE",
        params,
      });
    },
    saveShopToDaDa({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/saveShopToDaDa`,
        name: "SAVE_SHOP_TO_DADA",
        params,
      });
    },
    queryThirdShopInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryThirdShopInfo`,
        name: "QUERY_THIRD_SHOP_INFO",
        params,
      });
    },
    editShopToDaDa({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/updateShopToDaDa`,
        name: "EDIT_SHOP_TO_DADA",
        params,
      });
    },
    queryWxLoginState({ commit }, params) {
      return post({
        commit,
        url: `/sys/thirdLogin/render/wechat_open`,
        name: "QUERY_WX_LOGIN_STATE",
        params,
      });
    },
    queryAliyunIpWhitelist({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=aliyun_ip_whitelist`,
        name: "ALIYUN_IP_WHITE_LIST",
        params,
      });
    },
    setAliyunIpWhitelist({ commit }, params) {
      return post({
        commit,
        url: `/aliyun/setAliyunIpWhitelist`,
        name: "SET_ALIYUN_IP_WHITE_LIST",
        params,
      });
    },
    queryStoreShopDepartList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartShopRel/queryDepartInfoByShopId`,
        name: "QUERY_STORE_SHOP_DEPART_LIST",
        params,
      });
    },
    queryDepartInfoByShopIdForStore({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartShopRel/queryDepartInfoByShopIdForStore`,
        name: "QUERY_DEPART_INFO_BY_SHOP_ID_FOR_STORE",
        params,
      });
    },
    queryStoreAllEnabledStatusShopList({ commit }, params) {
      return post({
        commit,
        url: `/store/storeShopInfo/queryAllEnabledStatenShop`,
        name: "QUERY_STORE_ALL_ENABLED_STATUS_SHOP_LIST",
        params,
      });
    },
    queryStoreOpenChangeShop({ commit }, params) {
      return post({
        commit,
        url: `/store/examineConfig/small/queryStoreExamineConfigStates`,
        name: "QUERY_STORE_OPEN_CHANGE_SHOP",
        params,
      });
    },
    queryMpsFuncInfoPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/pageList`,
        name: "QUERY_MPS_FUNC_INFO_PAGE_LIST",
        params,
      });
    },
    editMpsFuncEnabledState({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/editEnabledState`,
        name: "EDIT_MPS_FUNC_ENABLED_STATE",
        params,
      });
    },
    addMpsFuncInfo({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/add`,
        name: "ADD_MPS_FUNC_INFO",
        params,
      });
    },
    queryMpsFuncVersionPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncVersionInfo/manage/pageList`,
        name: "QUERY_MPS_FUNC_VERSION_PAGE_LIST",
        params,
      });
    },
    queryMpsFuncWhiteConfigProvince({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/whiteConfigProvince`,
        name: "QUERY_MPS_FUNC_WHITE_CONFIG_PROVINCE",
        params,
      });
    },
    queryMpsFuncWhiteConfigStore({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/whiteConfigStore`,
        name: "QUERY_MPS_FUNC_WHITE_CONFIG_STORE",
        params,
      });
    },
    queryMpsFuncWhiteConfigShop({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/whiteConfigShop`,
        name: "QUERY_MPS_FUNC_WHITE_CONFIG_SHOP",
        params,
      });
    },
    queryMpsFuncWhiteConfigGuider({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/whiteConfigGuider`,
        name: "QUERY_MPS_FUNC_WHITE_CONFIG_GUIDER",
        params,
      });
    },
    saveMpsFuncWhiteConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/saveWhiteConfig`,
        name: "SAVE_MPS_FUNC_WHITE_CONFIG",
        params,
      });
    },
    searchWhiteConfigTree({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/whiteConfigSearch`,
        name: "SEARCH_WHITE_CONFIG_TREE",
        params,
      });
    },
    queryCheckedMpsFuncStoreCustomerConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/manage/queryCheckedWhiteConfigCustomer`,
        name: "QUERY_CHECKED_MPS_FUNCSTORE_CUSTOMER_CONFIG",
        params,
      });
    },
    querySupplierAuditList({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/listAudit`,
        name: "QUERY_SUPPLIER_AUDIT_LIST",
        params,
      });
    },
    saveSupplierAudit({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/addAudit`,
        name: "SAVE_SUPPLIER_AUDIT",
        params,
      });
    },
    editSupplierAudit({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/editAudit`,
        name: "EDIT_SUPPLIER_AUDIT",
        params,
      });
    },
    bulkOperConfigs({ commit }, params) {
      return post({
        commit,
        url: `/decision/supplierAuditDecisionConfig/bulkOperConfigs`,
        name: "BULK_OPERCONFIGS",
        params,
      });
    },
    editDelFlagSupplierAudit({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/editDelFlagAudit`,
        name: "EDIT_DEL_FLAG_SUPPLIER_AUDIT",
        params,
      });
    },
    //修改组织架构
    editOrganizationBasic({ commit }, params) {
      return post({
        commit,
        url: `/store/storeDepartInfo/editBasicInfo`,
        name: "EDIT_ORGANIZATION_BASIC",
        params,
      });
    },
    //新增退货地址
    storeAddressInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/config/storeAddressInfo/add`,
        name: "STORE_ADDRESS_INFO_ADD",
        params,
      });
    },
    //查询退货地址列表
    storeAddressInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/config/storeAddressInfo/queryPageList`,
        name: "STORE_ADDRESS_INFO_QUERY_PAGE_LIST",
        params,
      });
    },
    //删除退货地址
    storeAddressInfoDelete({ commit }, params) {
      return post({
        commit,
        url: `/config/storeAddressInfo/delete`,
        name: "STORE_ADDRESS_INFO_DELETE",
        params,
      });
    },
    //扫呗支付配置列表
    saoBeiList({ commit }, params) {
      return post({
        commit,
        url: `/saobei/config/list`,
        name: "SAOBEI_LIST",
        params,
      });
    },
    //扫呗支付配置新增
    saoBeiAdd({ commit }, params) {
      return post({
        commit,
        url: `/saobei/config/add`,
        name: "SAOBEI_ADD",
        params,
      });
    },
    //扫呗支付配置编辑
    saoBeiEdit({ commit }, params) {
      return post({
        commit,
        url: `/saobei/config/edit`,
        name: "SAOBEI_EDIT",
        params,
      });
    },
    //扫呗支付配置删除
    saoBeiDelete({ commit }, params) {
      return post({
        commit,
        url: `/saobei/config/delete`,
        name: "SAOBEI_DELETE",
        params,
      });
    },
    removeAuditManager({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/remove`,
        name: "REMOVE_AUDIT_MANAGER",
        params,
      });
    },
    addAuditManager({ commit }, params) {
      return post({
        commit,
        url: `/supplier/audit/manage/add`,
        name: "ADD_AUDIT_MANAGER",
        params,
      });
    },
    storeSystemParamInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/queryPageList`,
        name: "STORE_SYSTEM_PARAM_INFOQUERY_PAGE_LIST",
        params,
      });
    },
    editValueById({ commit }, params) {
      return post({
        commit,
        url: `/storepermissions/storeSystemParamInfo/editValueById`,
        name: "EDIT_VALUE_BY_ID",
        params,
      });
    },
    onlineList({ commit }, params) {
      return post({
        commit,
        url: `/sys/online/list`,
        name: "ONLINE_LIST",
        params,
      });
    },
    frozenUsername({ commit }, params) {
      return post({
        commit,
        url: `/store/storeEmployeeInfo/frozenUsername`,
        name: "FROZEN_USERNAME",
        params,
      });
    },
    forceLogout({ commit }, params) {
      return post({
        commit,
        url: `/sys/online/forceLogout`,
        name: "FORCE_LOGOUT",
        params,
      });
    },
    showSuperAdmin({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/showSuperAdmin`,
        name: "SHOW_SUPER_ADMIN",
        params,
      });
    },
    setSuperAdmin({ commit }, params) {
      return post({
        commit,
        url: `/sys/user/setSuperAdmin`,
        name: "SET_SUPER_ADMIN",
        params,
      });
    },
    //查询缓存数量
    queryCacheCount({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/queryCacheCount`,
        name: "QUERY_CACHE_COUNT",
        params,
      });
    },
    //清理缓存
    clearCache({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/clearCache`,
        name: "CLEAR_CACHE",
        params,
      });
    },
    //查询缓存配置
    queryCacheSettings({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/queryCacheSettings`,
        name: "QUERY_CACHE_SETTINGS",
        params,
      });
    },
    //更新缓存配置
    updateCacheSettings({ commit }, params) {
      return post({
        commit,
        url: `/store/mpsFuncInfo/updateCacheSettings`,
        name: "UPDATE_CACHE_SETTINGS",
        params,
      });
    },
    // 查询发货单推送记录
    omsOrderSendPage({ commit }, params) {
      return post({
        commit,
        url: `/omsOrder/omsOrderSendPage`,
        name: "OMS_ORDER_SEND_PAGE",
        params,
      });
    },
    // 查询发货单推送记录
    omsOrderRefundInfoPage({ commit }, params) {
      return post({
        commit,
        url: `/omsOrder/omsOrderRefundInfoPage`,
        name: "OMS_ORDER_REFUND_INFO_PAGE",
        params,
      });
    },
    // scrm调度记录分页列表查询
    queryRewardGoodsImportEsPageList({ commit }, params) {
      return post({
        commit,
        url: `/system/sysSchedulingRecord/queryRewardGoodsImportEsPageList`,
        name: "QUERY_REWARD_GOODS_IMPORT_ES_PAGELIST",
        params,
      });
    },
    // 【红包自动化】step1-处理ocr文本
    getVolcengineOcrResult({ commit }, params) {
      return post({
        commit,
        url: `/provider/redpackage/micro/supplierAutoProcessOcrText/getVolcengineOcrResult`,
        name: "GET_VOLCENGINE_OCR_RESULT",
        params,
      });
    },
    // 职员管理 导入门店
    storeShopEmployeeFinanceRelImportShop({ commit }, params) {
      return post({
        commit,
        url: `/badge/storeShopEmployeeFinanceRel/importShop`,
        name: "STORE_SHOP_EMPLOYEE_FINANCE_REL_IMPORT_SHOP",
        params,
      });
    },
    // 导出商店管理
      storeShopInfoExport({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/store/storeShopInfo/export/storeShopInfo/list`,
        name: "STORE_SHOP_INFO_EXPORT",
        params,
      });
    },
    // 三方配置列表
    thirdCompanyOpenPlatformConfigQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/openplatform/thirdCompanyOpenPlatformConfig/queryPageList`,
        name: "THIRD_COMPANY_OPEN_PLATFORM_CONFIG_QUERY_PAGE_LIST",
        params,
      });
    },
    // 三方配置新增接口
    thirdCompanyOpenPlatformConfigAdd({ commit }, params) {
      return post({
        commit,
        url: `/openplatform/thirdCompanyOpenPlatformConfig/add`,
        name: "THIRD_COMPANY_OPEN_PLATFORM_CONFIG_ADD",
        params,
      });
    },
    // 三方配置编辑接口
    thirdCompanyOpenPlatformConfigUpdate({ commit }, params) {
      return post({
        commit,
        url: `/openplatform/thirdCompanyOpenPlatformConfig/updateConfig`,
        name: "THIRD_COMPANY_OPEN_PLATFORM_CONFIG_UPDATE",
        params,
      });
    },
    // 三方配置生成密钥接口
    thirdCompanyOpenPlatformConfigGenerateAccessKeyPair({ commit }, params) {
      return post({
        commit,
        url: `/openplatform/thirdCompanyOpenPlatformConfig/generateAccessKeyPair`,
        name: "THIRD_COMPANY_OPEN_PLATFORM_CONFIG_GENERATE_ACCESS_KEY_PAIR",
        params,
      });
    },
    // 三方配置-操作记录
    thirdCompanyOpenPlatformConfigOperationRecord({ commit }, params) {
      return post({
        commit,
        url: `/openplatform/thirdInterfaceCallbackLogManager/queryEsPageList`,
        name: "THIRD_COMPANY_OPEN_PLATFORM_CONFIG_OPERATION_RECORD",
        params,
      });
    },
//查询回调日志业务类型 - 字典
 queryCallbackLogBizType({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=CallbackLogBizType`,
        name: "QUERY_CALLBACK_LOG_BIZ_TYPE",
        params,
      });
    },
    //回调日志完成状态 - 字典
 queryCallbackLogFinishState({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=CallbackLogFinishState`,
        name: "QUERY_CALLBACK_LOG_FINISH_STATE",
        params,
      });
    },
       //获取省市区json
   getProvinceCityAreaJson({ commit }, params) {
      return post({
        commit,
        url: `/provider/tenant/micro/system/sysFileTemplate/queryById`,
        name: "GET_PROVINCE_CITY_AREA_JSON",
        params,
      });
    },
        //MOP退款报错重试
   getRefundCancelRetry({ commit }, params) {
      return post({
        commit,
        url: `/provider/thirderp/refund/mop/refund/cancel/retry`,
        name: "GET_REFUND_CANCEL_RETRY",
        params,
      });
    },
  },
};

export default system;
